import type { OpenParams } from '../types';

const PREFIX = '#modal:forma-rent';
const KNOWN_KEYS: ReadonlyArray<keyof OpenParams> = ['product', 'option', 'category'];

/**
 * Парсит hash вида `#modal:forma-rent[product=123&option=456&category=...]`.
 * Возвращает OpenParams или null если префикс не совпал / скобки кривые.
 */
export function parseHash(hash: string): OpenParams | null {
  if (!hash.startsWith(PREFIX)) return null;

  const tail = hash.slice(PREFIX.length);

  // Ровно префикс — пустые параметры.
  if (tail === '') return {};

  // Любой непустой tail обязан начинаться с '[' и заканчиваться ']'.
  if (tail[0] !== '[' || tail[tail.length - 1] !== ']') return null;

  const inner = tail.slice(1, -1);
  if (inner === '') return {};

  const result: OpenParams = {};

  for (const pair of inner.split('&')) {
    const eqIndex = pair.indexOf('=');
    if (eqIndex === -1) continue;

    const rawKey = pair.slice(0, eqIndex);
    const rawValue = pair.slice(eqIndex + 1);

    if (rawValue === '') continue;
    if (!(KNOWN_KEYS as ReadonlyArray<string>).includes(rawKey)) continue;

    let value: string;
    try {
      value = decodeURIComponent(rawValue);
    } catch {
      continue;
    }

    // Безопасно по известному списку ключей.
    (result as Record<string, string>)[rawKey] = value;
  }

  return result;
}
